export const ParticipantsTableWidth = {
  type: 180,
  street: 250,
  zipCode: 120,
  city: 180,
  deactivatedAtUtc: 180,
};
